module.exports = __webpack_public_path__ + "static/media/IMG_6759_2.314c4d6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/photos/IMG_6759_2.jpg
// module id = 216
// module chunks = 0